import { defineMessages } from "react-intl";

const messages = defineMessages({
  confirmEditMessage: {
    id: "app.admin-edit-distributor-product-code-product.confirmEditMessage",
    description: "confirm edit message",
    defaultMessage: "Kindly note that by choosing to edit, any unsaved new fields will be deleted. to avoid this, please save the new fields first then edit the status afterwards",
  },
  save: {
    id: "app.admin-edit-distributor-product-code-product.saveBtn",
    description: "save",
    defaultMessage: "SAVE",
  },
  cancel: {
    id: "app.admin-edit-distributor-product-code-product.cancelBtn",
    description: "cancel",
    defaultMessage: "CANCEL",
  },
});

export default messages;
